module.exports = __webpack_public_path__ + "public/images/slider/oleynikova.d03f83c8f7d004adabfedd717b08859b.jpg";